export default __webpack_public_path__ + "static/media/doctor-4.a664fbb5.jpg";